import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the ContentReplacePipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'contentReplace',
})
export class ContentReplacePipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: string, ...args) {
    return value.replace("%"+args[0]+"%", args[1]);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/content-replace/content-replace.ts